module.exports = __webpack_public_path__ + "img/Porto Apartment - 2 of 85.b4cbf52c.jpeg";